import { ReportHeadway } from '@/types/officialReport'

export const isHeadwayValid = (headway: Partial<Omit<ReportHeadway, 'id'>>): boolean =>
    !Object.values(headway).some((item) => !item)
